<template>
  <div class="company-wall-details-reviews-skeleton">
    <div class="company-wall-details-reviews-skeleton__heading-mobile">
      <PSkeleton height="30px" style="width: 80%" />
      <PSkeleton height="30px" style="width: 50%" />

      <div class="company-wall-details-reviews-skeleton__description">
        <PSkeleton height="18px" style="width: 90%" />
        <PSkeleton height="18px" style="width: 93%" />
        <PSkeleton height="18px" style="width: 88%" />
        <PSkeleton height="18px" style="width: 70%" />
      </div>
    </div>

    <div class="company-wall-details-reviews-skeleton__heading-desktop">
      <PSkeleton height="30px" width="465px" />

      <div class="company-wall-details-reviews-skeleton__description">
        <PSkeleton height="18px" style="width: 95%" />
        <PSkeleton height="18px" style="width: 85%" />
      </div>
    </div>

    <div>
      <SReviewsSkeleton />
      <SPaginatorSkeleton />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  PSkeleton,
  SPaginatorSkeleton,
  SReviewsSkeleton,
} from "@solvari/components";
</script>

<style lang="postcss">
.company-wall-details-reviews-skeleton {
  @apply flex flex-col gap-8;

  &__heading-desktop,
  &__heading-mobile {
    @apply flex flex-col gap-1;
  }

  &__heading-desktop {
    @apply hidden;
  }

  &__description {
    @apply mt-2 flex flex-col gap-1;
  }

  @screen 600 {
    &__heading-mobile {
      @apply hidden;
    }
    &__heading-desktop {
      @apply flex flex-col gap-1;
    }
  }
}
</style>
